import * as React from "react";
import { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import useActiveQueryId from "views/hooks/useActiveQueryId";
import AddToQueryHandler from "views/logic/valueactions/AddToQueryHandler";
import useViewsDispatch from "views/stores/useViewsDispatch";
const handleAddToQuery = (dispatch, queryId, id, fieldType) => {
  const field = "associated_assets";
  return dispatch(AddToQueryHandler({ queryId, field, value: id, type: fieldType }));
};
const FormatAssetList = ({ associated_assets, fieldType }) => {
  const pluggableAssetListComponent = usePluginEntities("views.components.assetInformationActions");
  const queryId = useActiveQueryId();
  const dispatch = useViewsDispatch();
  const assetsList = useMemo(
    () => pluggableAssetListComponent.map(({ component: PluggableAssetListItem }) => /* @__PURE__ */ React.createElement(
      PluggableAssetListItem,
      {
        key: associated_assets[0],
        assetIds: associated_assets,
        direction: "col",
        addToQuery: (id) => handleAddToQuery(dispatch, queryId, id, fieldType)
      }
    )),
    [pluggableAssetListComponent, associated_assets, dispatch, queryId, fieldType]
  );
  if (associated_assets.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, assetsList.map((assetElement) => /* @__PURE__ */ React.createElement("div", { key: assetElement.props.assetIds[0] }, assetElement)));
};
export default FormatAssetList;
